import React from "react";
import stores from "../../data/store";

function StaticMap({ locations }) {
  const isMobile = window.innerWidth <= 600;

  const isDefaultView = locations === stores;
  const romfordUrl =
    "https://maps.google.com/maps?q=Romford+Asia+Villa&output=embed&hl=en";

  const zoom = locations.length === 1 ? 13 : 9;
  const mapUrl = isDefaultView
    ? romfordUrl
    : `https://maps.google.com/maps?output=embed&hl=en&z=${zoom}&${locations
        .map((loc) => `q=${encodeURIComponent(loc.Name)}:${loc.lat},${loc.lng}`)
        .join("&")}`;

  return (
    <div className={isMobile ? "mobileimage" : "staticMap"}>
      <iframe title="Asia Villa stores map" src={mapUrl} frameBorder="0" />
    </div>
  );
}

export default StaticMap;
